import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  style: {"color":"var(--cor_layout_1)"},
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_3 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'CampCropImageLoader',
  props: {
  isLoading: Boolean,
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (__props.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : _createCommentVNode("", true)
}
}

})